import { render, staticRenderFns } from "./index.vue?vue&type=template&id=af04e510&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=af04e510&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=af04e510&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af04e510",
  null
  
)

export default component.exports